module.exports = "<div class=\"pricing-card\" id=\"nests-and-counties\">\n  <div class=\"pricing-card-header\">\n    קינים ומחוזות\n  </div>\n  <div class=\"pricing-card-content\">\n\n    <div class=\"app-input-wrapper search-nests\">\n      <input\n        class=\"search-input app-input\"\n        placeholder=\"הוסיפו קינים ומחוזות\" type=\"text\"\n      />\n      <i class=\"fa fa-search\"></i>\n    </div>\n\n    <div class=\"nests-list\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/form/generic-auto-complete/generic-auto-complete.component.html
// module id = ./src/app/form/generic-auto-complete/generic-auto-complete.component.html
// module chunks = main